import './Editor.c38abec64a1e69c13510fd94f266888a.css';
export default {"scrollContainer":"_scrollContainer_1ikp2_1","scrollInner":"_scrollInner_1ikp2_1","editor":"_editor_1ikp2_1","toolbar":"_toolbar_1ikp2_1","sticked":"_sticked_1ikp2_1"};